import { Component, EventEmitter, HostBinding, HostListener, Input, Output } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FaIconComponent } from "@fortawesome/angular-fontawesome";

@Component({
  selector: "app-toggle-button",
  templateUrl: "./toggle-button.component.html",
  standalone: true,
  imports: [CommonModule, FaIconComponent],
  styleUrl: "./toggle-button.component.scss",
})
export class ToggleButtonComponent {
  @Input() isActive = false;
  @Output() toggle = new EventEmitter<boolean>();

  @HostBinding("class.is-active") get getIsActive(): boolean {
    return this.isActive;
  }

  @HostListener("click") onClick(): void {
    this.isActive = !this.isActive;
    setTimeout(() => {
      this.toggle.emit(this.isActive);
    }, 200);
  }
}
